function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPinRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.395 11.109l-6.503-6.504a2.067 2.067 0 00-2.925.002l-.217.218a1.967 1.967 0 00-.602 1.431c.024.797-.268 2.228-2.079 4.038-1.946 1.947-4.773 1.58-6.295 1.185a2.054 2.054 0 00-1.959.551l-.21.21a2.068 2.068 0 000 2.924l10.23 10.23a2.067 2.067 0 002.923 0l.21-.21a2.053 2.053 0 00.55-1.959c-.394-1.521-.76-4.349 1.186-6.295 1.808-1.808 3.237-2.1 4.035-2.075a1.966 1.966 0 001.437-.604l.218-.219a2.067 2.067 0 000-2.923zM4 26v2h2l5.306-5.306-2-2L4 26z",
    fill: props.color
  }));
}

export default SvgIconPinRexFilled;